"use client";

import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { track } from "@/components/analytics/track";

/**
 * Final close — the engine-to-live claim, then the trial.
 */
export function ClosingCta() {
  const t = useTranslations("Home");

  return (
    <section className="relative overflow-hidden px-4 py-24 sm:px-6">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(15,92,71,0.28),transparent_62%)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 top-0 h-72 w-72 rounded-full bg-maroon/20 blur-[90px]"
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5 }}
        className="relative z-10 mx-auto w-full max-w-3xl px-1 text-center"
      >
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-teal-light">
          {t("closeEyebrow")}
        </p>
        <h2 className="mx-auto mb-5 max-w-[20.5rem] text-[clamp(1.5rem,6vw,3rem)] font-bold tracking-tight text-pretty text-slate-100 sm:max-w-none">
          {t("closeTitle")}
        </h2>
        <p className="mx-auto mb-10 w-full max-w-[20.5rem] text-base leading-relaxed text-slate-400 sm:max-w-xl sm:text-lg">
          {t("closeSubtitle")}
        </p>
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            href="/product"
            onClick={() =>
              track("cta_click", { meta: { label: "close_download" } })
            }
            className="group inline-flex items-center gap-2 rounded-lg bg-maroon px-8 py-4 font-semibold text-white shadow-lg shadow-maroon/25 transition-all duration-200 hover:bg-maroon-hover"
          >
            {t("downloadCta")}
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Link>
          <Link
            href="/#product-demo"
            onClick={() =>
              track("cta_click", { meta: { label: "close_watch_demo" } })
            }
            className="inline-flex items-center gap-2 rounded-lg border border-teal-light/50 bg-teal-primary/20 px-8 py-4 font-medium text-teal-light transition-colors hover:border-teal-light hover:bg-teal-primary/30 hover:text-white"
          >
            <Play className="h-4 w-4 fill-current" />
            {t("watchDemo")}
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
